<button *ngIf="isShow" (click)="scrollToTop()" class="back-to-top-btn">
  <span>{{ 'account.BacktoTop' | cxTranslate }}</span> <i class="fa fa-arrow-up"></i>
</button>
